import { ReferencePage } from './Reference'

/**
 * Die acht Fachkapitel.
 *
 * Sie stehen in EINER Datei, weil sie sich nur durch vier Zeichenketten
 * unterscheiden — der Inhalt liegt in `public/reference/`. Acht Dateien mit
 * je einem Aufruf wären acht Dateien ohne eigene Aussage.
 */

/**
 * P00 ist das einzige Kapitel, das GEGEN diese Anwendung rechnet.
 *
 * Die anderen sieben erklären, wie ein Gang zustande kommt. Dieses hier nimmt
 * einen fremden Konstruktionsstand — den proximalen Knieantrieb — und hält ihn
 * neben die Zahlen, mit denen der Simulator arbeitet. Dabei kommen
 * Abweichungen heraus, die keine Schönheitsfehler sind: 960 mm Bein gegen
 * 814 mm entscheiden darüber, ob 5 m/s erreichbar sind oder nicht.
 *
 * Deshalb steht es NICHT bei den Grundlagen, sondern als eigener Punkt. Ein
 * Kapitel, das eine offene Frage an das eigene Modell stellt, gehört nicht in
 * den Anhang.
 */

export const KneePage = () => (
  <ReferencePage
    slug="p00"
    title="P00 Knie"
  />
)

export const DocumentationPage = () => (
  <ReferencePage
    slug="grundlagen"
    title="Grundlagen"
  />
)

export const AssemblyPage = () => (
  <ReferencePage
    slug="aufbau"
    title="Aufbau"
  />
)

export const ArchitecturePage = () => (
  <ReferencePage
    slug="architektur"
    title="Architektur"
  />
)

export const ConceptPage = () => (
  <ReferencePage
    slug="konzept"
    title="Konzept"
    tools
  />
)

export const SoftwarePage = () => (
  <ReferencePage
    slug="software"
    title="Software"
  />
)

export const MarketPage = () => (
  <ReferencePage
    slug="markt"
    title="Marktdossier"
  />
)

export const PracticePage = () => (
  <ReferencePage
    slug="praxis"
    title="Praxis"
  />
)
